import "./DialogComponent.scss";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import translate from "../../../i18n/translate";

const DialogComponent = (props: any) => {
  return (
      <Dialog
        open={props.openDialog}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialog-wrapper"
      >
        {props.perPartBadgePercentage >= 0 && <div data-testid="correct-percent" className="dialog-correctness-percentage">{translate("progress_total_correctness_percentage")}<strong>{props.perPartBadgePercentage}%</strong></div>}
        {props.title !== "" && <DialogTitle className="dialog-title">{props.title}</DialogTitle>}
        <DialogContent className="dialog-text">{props.children}</DialogContent>
        <img
          onKeyDown={() => {}}
          data-testid="close-button"
          src={"../../../images/close-icon.svg"}
          className={"close-icon general-clickable"}
          onClick={props.handleClose}
          alt="close"
        />
      </Dialog>
  );
};

export default DialogComponent;
